import $ from 'jquery';
import { fromLegacyTimeZone, toIANATimeZone } from '@bingads-webui-universal/time-zone-converter';
import { ReconciliationReport } from '@bingads-webui/hotel-odata-schemas';
import jsdata from '@bingads-webui-campaign-legacy/hotel-center-js-data/index';
import { getHotelCenterUtils } from '@bingads-webui-campaign/hotel-center-utils';
import pageContext from '@bingads-webui-static-legacy/page-context';
import { withoutTime } from '@bingads-webui/primitive-utilities';
import edm from '@bingads-webui-campaign-legacy/hotel-center-edm/index';
import globalConfig from '@bingads-webui-component-legacy/config/index';
import { bingadsGridColumn } from '@bingads-webui-component-legacy/bingads-grid/shared/column';

function parseDate(dateStr) {
  const year = dateStr.substr(0, 4);
  const month = Number(dateStr.substr(4, 2) - 1);
  const day = dateStr.substr(6, 2);
  const hour = dateStr.substr(8, 2);
  const min = dateStr.substr(10, 2);
  const sec = dateStr.substr(12, 2);
  const millSec = dateStr.substr(14, 3);
  return new Date(year, month, day, hour, min, sec, millSec);
}

export class GridOption {
  constructor({
    i18n, dateFilterContainer, reportType, perfMarker,
  } = {}) {
    this.i18n = i18n;
    this.name = 'HotelCenterProcessedReconGrid';
    this.tableClasses = ['table', 'table-bordered'];

    this.dataSource = {
      type: 'js-data',
      entity: jsdata.ReconciliationReport,
      schema: ReconciliationReport,
      options: {
        cacheResponse: false,
        entitySet: edm.currentAccount.ReconciliationReports['Default.GetReconciliationReports'].$call({
          ReportType: reportType,
        }),
      },
      query: {
        $orderby: reportType === 'ProcessedReconciliationReport' ? 'ProcessedDateTime desc' : 'UploadDateTime desc',
      },
    };
    this.columns = [
      bingadsGridColumn({
        name: reportType === 'ProcessedReconciliationReport' ? 'ProcessedDateTime' : 'UploadDateTime',
        title: reportType === 'ProcessedReconciliationReport' ? i18n.getString(_TL_('Processed date & time')) : i18n.getString(_TL_('Uploaded date & time')),
        template: local => i18n.formatDate(parseDate(local.value), {
          datetime: 'full',
          timeZone: toIANATimeZone(fromLegacyTimeZone(pageContext.AccountTimeZone)),
        }),
      }),
      bingadsGridColumn({
        name: 'UserFileName',
        title: reportType === 'ProcessedReconciliationReport' ? i18n.getString(_TL_('Processed file')) : i18n.getString(_TL_('Uploaded file')),
        template: local => `<a href="javascript:" class="download-recon">${local.value}</a>`,
      }),
      bingadsGridColumn({
        name: 'summary',
        property: {
          get: item => `${item.SuccessCount} ${i18n.getString(_TL_('matched'))} | ${item.ErrorCount} ${i18n.getString(_TL_('unmatched'))}`,
        },
        title: i18n.getString(_TL_('Summary')),
      }),
    ];

    const includeRanges = ['custom', 'customTime', 'today', 'yesterday', 'thisWeekSunday', 'thisWeekMonday', 'lastSevenDays', 'lastWeekSunday', 'lastWeekMonday', 'lastFourteenDays', 'last30Days'];

    const { dateUtils } = getHotelCenterUtils({ pageContext });
    const maxDate = withoutTime(dateUtils.local2account(new Date()));
    maxDate.setDate(maxDate.getDate() + 1);

    this.plugins = {
      perfMarker: {
        appConfig: globalConfig,
        marker: perfMarker,
      },
      a11y: { i18n },
      uiBlocker: {
        el: $('.recon-grid'),
      },
      dateFilter: {
        container: dateFilterContainer,
        isComparisonEnabled: false,
        odataTimeZone: 'UTC',
        enabledRangesPredicate: range => includeRanges.indexOf(range.key) !== -1,
        sharedInGrids: false,
        maxDate,
        upToNowWhenToday: false,
      },
      placeholder: {
        container: '.grid-noresult',
        text: i18n.getString(_TL_('There are no reconciliation reports based on your filtered search.')),
      },
      pagination: {
        pageSize: 20,
        availablePageSizes: [20, 50, 100, 200],
        enableRandomPage: false,
      },
    };
  }
}
